import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Layout from './components/Layout/Layout';
import Home from './pages/Home/Home';
import NoPageFound from './pages/NoPageFound';
import Contact from './pages/Contact/Contact';
import About from './pages/About/About';
import Products from './pages/Products/Products';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import WhyUs from './pages/WhyUs/WhyUs';

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="contact" element={<Contact />} />
          <Route path="about-us" element={<About />} />
          <Route path="products" element={<Products />} />
          <Route path="why-us" element={<WhyUs />} />
          <Route path="*" element={<NoPageFound />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
